// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.
import { RTK_PROMISE_TRACKER_ID } from '@shared/data-access/utils/constants';
import { type FC } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { usePromiseTracker } from 'react-promise-tracker';
import styles from './loading-splash.module.css';

export type LoadingSplashProps = {
  readonly area?: string;
  readonly delay?: number;
};

export const LoadingSplash: FC<LoadingSplashProps> = ({
  area = RTK_PROMISE_TRACKER_ID,
  delay = 1000,
}) => {
  const { i18n } = useTranslation();

  const { promiseInProgress } = usePromiseTracker({
    area,
    delay,
  });

  return createPortal(
    <div
      className={styles['loading-splash-screen']}
      aria-hidden={!promiseInProgress}
      data-testid="loading-splash"
    >
      <div className={styles['loading-splash-backdrop']}>
        <div className={styles['loading-splash-stack']}>
          <div className={styles['loading-splash-bars']} />

          <span className={styles['loading-splash-phrase']} lang={i18n.language} />
        </div>
      </div>
    </div>,
    document.body,
    'splash-screen',
  );
};
